import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ChevronIcon from '@assets/img/icons/chevron.svg?react';
import cn from 'classnames';

import { AppRoute } from '@/common/app/routes';
import { StringSmall, StringXSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';
import { useAppSelector } from '@/redux/store';

import { useVisitTask } from './visit-task.hook';

import css from './styles.module.scss';

import taskListPng from '/img/icons/task-list.png';
import taskListWebp from '/img/icons/task-list.webp';

const NextTask: FC = () => {
  const lastSocial = useAppSelector(
    (state) => state.tasks?.social?.slice(-1)[0],
  );

  const lastPartner = useAppSelector(
    (state) => state.tasks?.partners?.slice(-1)[0],
  );
  const { t } = useTranslation();
  const navigate = useNavigate();

  const partnerTask = useVisitTask('lastVisitedPartnerTaskId', lastPartner);
  const socialTask = useVisitTask('lastVisitedSocialTaskId', lastSocial);

  const isTaskVisited = partnerTask.isVisited && socialTask.isVisited;

  return (
    <div
      onClick={() => {
        partnerTask.saveVisit();
        socialTask.saveVisit();
        navigate(AppRoute.EARN);
      }}
      className={cn(css.nextTask, !isTaskVisited && css['nextTask--unvisited'])}
    >
      <Picture
        img={taskListPng}
        webp={taskListWebp}
        className="size-10 shrink-0 mr-2"
        alt="task"
      />
      <div className="flex flex-col gap-[2px] flex-1 min-w-[0%]">
        <StringXSmall className="!text-white/40">{t('Tasks')}</StringXSmall>
        <StringSmall
          weight="medium"
          className="text-ellipsis whitespace-nowrap overflow-hidden"
        >
          {partnerTask?.data?.title || socialTask?.data?.title}
        </StringSmall>
      </div>
      <ChevronIcon className="text-white/40 size-6 shrink-0" />
    </div>
  );
};

export { NextTask };
